import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import PerPageOptions from "./PerPageOptions";
import PreviousAndNextButtons from "./PreviousAndNextButtons";
import CurrentItemsLabel from "./CurrentItemsLabel";

export default function PaginationFooter(props) {
  const {
    numPerPageOptions,
    numItemsPerPage,
    numItems,
    currentPage,
    onPerPageChange,
    onPageChange
  } = props;
  return (
    <Box display="flex" flexDirection={{ xs: "column", sm: "row" }}>
      <Box
        display="flex"
        alignItems="center"
        flex={1}
        justifyContent={{ xs: "center", sm: "flex-start" }}
      >
        <CurrentItemsLabel
          numItems={numItems}
          numItemsPerPage={numItemsPerPage}
          currentPage={currentPage}
        />
        <PerPageOptions
          numPerPageOptions={numPerPageOptions}
          numItemsPerPage={numItemsPerPage}
          onPerPageChange={onPerPageChange}
        />
      </Box>
      <Box
        display="flex"
        justifyContent={{ xs: "center", sm: "flex-start" }}
        flex={2}
        mt={{ xs: 2, sm: 0 }}
      >
        <Box display="flex" flexBasis="50%" justifyContent="center">
          <PreviousAndNextButtons
            onNextClick={() => onPageChange(currentPage + 1)}
            onPrevClick={() => onPageChange(currentPage - 1)}
            hasPrevPage={currentPage !== 0}
            hasNextPage={numItems > (currentPage + 1) * numItemsPerPage}
          />
        </Box>
      </Box>
    </Box>
  );
}

PaginationFooter.propTypes = {
  onPageChange: PropTypes.func,
  onPerPageChange: PropTypes.func,
  currentPage: PropTypes.number,
  itemsType: PropTypes.string,
  numItems: PropTypes.number,
  numItemsPerPage: PropTypes.string,
  numPerPageOptions: PropTypes.arrayOf(PropTypes.string)
};
